export const EVENT_NAME = {
  NEW_DEVICE_LOGIN_ATTEMPT: 'New Device Login Attempt',
  PROMPT_SENT_TO_TRUSTED_DEVICE: 'Prompt Sent To Trusted Device',
  FALLBACK_IDENTITY_VERIFICATION_STARTED:
    'Fallback Identity Verification Started',
  MANUAL_VERIFICATION_FAILED: 'Manual Verification Failed',
  NEW_DEVICE_LOGIN_INPUT_PASSWORD_SUCCESS:
    'New Device Login Input Password Success',
  NEW_DEVICE_LOGIN_INPUT_PIN_SUCCESS: 'New Device Login Input Pin Success',
  NEW_DEVICE_LOGIN_OTP_VERIFIED: 'New Device Login Otp Verified',
  NEW_DEVICE_LOGIN_COMPLETED: 'New Device Login Completed',
};
